import { createRoot } from 'react-dom/client';
import App from './app';
import '@fontsource/oxygen';

const root = createRoot(document.getElementById('content')!);
root.render(<App />);
